import { createContext, useReducer } from "react";
import webState from "./State";
import webReducers from "./Reducers";

export const WebContext = createContext(webState);

const WebProvider = ({children}: {children: React.ReactNode}) => {
    const [state, dispatch] = useReducer(webReducers, webState);

    return (
        <WebContext.Provider value={{...state, dispatch}}>
            {children}
        </WebContext.Provider>
    )
}

export default WebProvider;